import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion'

import {
    AppContent,
    BlockChainContent,
    CyberContent,
    servicesName,
    SoftwareContent,
    webAppContent,
} from "./Consultingdata";


const ConsultingSection = ({ darkToggle }) => {

    const [content, setcontent] = useState(webAppContent);
    const navigate = useNavigate()

    const handleClick = (item) => {
        if (item === "Web App Development") {
            setcontent(webAppContent);
        } else if (item === "Cybersecurity") {
            setcontent(CyberContent);
        } else if (item === "Blockchain Development") {
            setcontent(BlockChainContent);
        } else if (item === "Software Development and Consultation") {
            setcontent(SoftwareContent);
        } else if (item === "Mobile App Development") {
            setcontent(AppContent);
        }
    };

    return (
        <div className="bg-gray-50 relative z-30 dark:bg-gray-900 transition-all duration-700  "

        >
            <div className="max-w-screen-2xl mx-auto px-2 md:px-5 py-6 md:py-10 ">
                <motion.div
                    whileInView={{ opacity: [0, 1] }}
                    transition={{ duration: 1.0 }}>
                    <div className="flex flex-col items-center gap-5 justify-center">
                        <p className=" text-2xl font-bold dark:text-white">
                            Software Consulting{" "}
                            <span className="text-red-500">
                                & <br /> Development Services
                            </span>
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-2 px-3 py-3 gap-5 lg:gap-8 md:py-5 w-full">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:grid-cols-3 w-full">
                                {servicesName.map((item, i) => (
                                    <div key={i}>
                                        <div
                                            onClick={() => handleClick(item.title)}
                                            className={`bg-white dark:bg-gray-800 shadow-sm py-6 px-1 min-h-[165px] hover:shadow-lg hover:scale-110 rounded-md duration-700 cursor-pointer flex flex-col items-center justify-center gap-2 ${item.title === content.title && 'shadow-lg font-bold'}`}
                                        >
                                            <img src={item.img} alt="" className="h-6 w-6 text-pink-600" />
                                            <p className="text-[12px] md:text-[15px] text-center dark:text-white">
                                                {item.title}
                                            </p>
                                        </div>
                                        {content.title === item.title && (
                                            <div className=" sm:hidden py-4">
                                                <h1 className="font-bold text-xl dark:text-white">
                                                    {content.title}
                                                </h1>
                                                <p className="my-3 text-[#757575] text-sm">
                                                    {content.desc}
                                                </p>
                                                <div className="flex gap-5 flex-wrap items-center">
                                                    {content.icons.map((item, i) => {
                                                        return <div key={i}>
                                                            <img src={item} alt="img" className="h-7 w-7" />
                                                        </div>
                                                    })}
                                                </div>
                                                <div className="mt-5">
                                                    <button
                                                        onClick={() => navigate(`/${content.link}`)}
                                                        className="rounded-xl px-5 py-1.5 overflow-hidden relative group cursor-pointer border-2 font-medium text-xs border-red-500 text-red-500 ">
                                                        <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-red-500 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                                                        <span className="relative text-red-500 transition duration-700 group-hover:text-white ease">View more</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            <div className="hidden sm:block">
                                <h1 className="font-bold text-xl dark:text-white">
                                    {content.title}
                                </h1>
                                <p className="my-3 text-[#757575] text-sm">
                                    {content.desc}
                                </p>
                                <div className="flex gap-5 flex-wrap items-center">
                                    {content.icons.map((item, i) => {
                                        return <div key={i} className='duration-700 hover:scale-90' onClick={() => window.scrollTo(0, 0)}>
                                            <img src={item} alt="img" className="h-7 w-7" />
                                        </div>
                                    })}
                                </div>
                                <div className="mt-5">
                                    <button
                                        onClick={() => navigate(`/${content.link}`)}
                                        className="rounded-xl px-5 py-1.5 overflow-hidden relative group cursor-pointer border-2 font-medium text-xs border-red-500 text-red-500 ">
                                        <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-red-500 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                                        <span className="relative text-red-500 transition duration-700 group-hover:text-white ease">View more</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default ConsultingSection;
